import { render, staticRenderFns } from "./MostLikelyMorphologicCodesModal.vue?vue&type=template&id=6a60ac3f&scoped=true&"
import script from "./MostLikelyMorphologicCodesModal.ts?vue&type=script&lang=ts&"
export * from "./MostLikelyMorphologicCodesModal.ts?vue&type=script&lang=ts&"
import style0 from "./MostLikelyMorphologicCodesModal.scss?vue&type=style&index=0&id=6a60ac3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60ac3f",
  null
  
)

export default component.exports